import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/paymentReport',
  	  method: 'get',
        params
  	})
  }

